import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { ShippingLabelReviewFields } from "./get-shipping-label-scan-review";

/**
 * Persists mid-review corrections on the scan, so a reload seeds the form
 * with the operator's edits instead of the bare parse.
 */
export const saveShippingLabelScanReview = {
  name: "saveShippingLabelScanReview" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    scanId: z.string(),
    fields: ShippingLabelReviewFields,
  }),
  output: z.object({ success: z.boolean() }),
};
